module.exports = __webpack_public_path__ + "static/media/logo.de1c7c99.png";